<template>
     <section class="perks" id="perks">
        <div class="container vld-parent">
            <loading :active.sync="isLoading" :background-color="'#000'" :color="'#ecd19a'" :opacity="0.7"></loading>
            <div>
                <h2>Subscription Perks</h2>
            </div>
            <div>
                <p class="section-description">
                    Below you will find the list of Perks that are included with an active Subscription.
                </p>
            </div>
            <div class="perkContainer">
                <div class="perktable">
                    <header>
                        <div class="perkCol">Game Purchase: No Subscription</div>
                        <div class="perkCol">Subscription Perks</div>
                    </header>
                    <div v-for="n in perkRowCount" :key="n" :class="n % 2 ? 'oddRow' : 'evenRow'">
                        <div class="perkCol"><span v-if="typeof gamePerks[n - 1] === 'undefined'"></span><span v-else >{{ gamePerks[n - 1] }}</span></div>
                        <div class="perkCol"><span v-if="typeof subPerks[n - 1] === 'undefined'"></span><span v-else >{{ subPerks[n - 1] }}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
        name: 'PerksComponent',
        components: { Loading },
        data() {
            return {
                perkRowCount: 0,
                isLoading: false,
                gamePerks: [],
                subPerks: []
            }
        },
        methods: {
            getData(){
                this.isLoading = true;
                this.axios.get(this.$config.api_url + "/My/Perks").then((response) => {
                    this.gamePerks = response.data.game;
                    this.subPerks = response.data.subscription;
                    this.perkRowCount = (this.subPerks.length > this.gamePerks.length) ? this.subPerks.length : this.gamePerks.length;
                    this.isLoading = false;
                }).catch(() =>  {
                    this.$toast.error('Error Retrieving Perks, Please Try again');
                    this.isLoading = false;
                });
            }
        },
        created() {
            this.getData();
        }
    }
</script> 